// Generated from public/static/main/front/ by the snippet in docs/plans/2026-10-15-front-page.md, Task 3.
// The intrinsic size of each front screenshot, so the page reserves its box before the image loads.

export const FRONT_SHOTS = {
  app_daytrader: { ext: "webp", width: 1800, height: 1125 },
  app_missions: { ext: "webp", width: 2684, height: 1672 },
  app_missions_board: { ext: "webp", width: 2684, height: 1672 },
  app_missions_cell: { ext: "webp", width: 2424, height: 1516 },
  app_missions_overview: { ext: "webp", width: 2684, height: 1672 },
  audit_debugger: { ext: "webp", width: 2560, height: 2266 },
  audit_thread: { ext: "webp", width: 1184, height: 1044 },
  build_node: { ext: "webp", width: 2880, height: 1800 },
  gal_basic_rag: { ext: "webp", width: 2036, height: 1200 },
  gal_deep_research: { ext: "webp", width: 2036, height: 1200 },
  gal_deep_research_playground: { ext: "webp", width: 2880, height: 1750 },
  gal_discussion_board: { ext: "webp", width: 2036, height: 1200 },
  gal_finance_ticker_data: { ext: "webp", width: 2036, height: 1200 },
  gal_open_canvas: { ext: "webp", width: 2036, height: 1200 },
  gal_trip_planner: { ext: "webp", width: 2036, height: 1200 },
  govern_policy: { ext: "webp", width: 1544, height: 1044 },
  hero_ask: { ext: "webp", width: 1184, height: 1044 },
  hero_editor: { ext: "webp", width: 2560, height: 1760 },
  hero_events: { ext: "webp", width: 744, height: 1226 },
  labs_ax_b: { ext: "webp", width: 2216, height: 1544 },
  labs_ax_g: { ext: "webp", width: 2216, height: 1544 },
  labs_bidaf: { ext: "webp", width: 2248, height: 1544 },
  labs_boolq: { ext: "webp", width: 2216, height: 1544 },
  labs_cb: { ext: "webp", width: 2216, height: 1544 },
  labs_conceptnet: { ext: "webp", width: 2216, height: 1384 },
  labs_copa: { ext: "webp", width: 2216, height: 1544 },
  labs_movies: { ext: "webp", width: 2216, height: 1384 },
  labs_multirc: { ext: "webp", width: 2216, height: 1544 },
  labs_object_detection: { ext: "webp", width: 2248, height: 1544 },
  labs_record: { ext: "webp", width: 2216, height: 1544 },
  labs_rte: { ext: "webp", width: 2216, height: 1544 },
  labs_super_resolution: { ext: "webp", width: 2248, height: 1544 },
  labs_wic: { ext: "webp", width: 2216, height: 1544 },
  labs_wikimedia: { ext: "webp", width: 2216, height: 1384 },
  labs_wsc: { ext: "webp", width: 2216, height: 1544 },
  worker_tui: { ext: "svg", width: 2214, height: 1026 },
};
